import { createReducer } from '@reduxjs/toolkit'
import {
  AIExternalActions,
  AIInternalActions,
} from '@store/reducers/ai/actions'

import type { AIState } from './types'

const initialState: AIState = {
  messages: [],
  remainingRequests: null,
  generating: false,
  historyLoading: false,
  error: null,
  cancelTokenSource: null,
  sessionId: null,
  streamingText: null,
  agentStep: null,
  agentStatus: null,
  lastSentMessage: null,
}

export const aiReducer = createReducer<AIState>(initialState, (builder) => {
  builder
    .addCase(
      AIInternalActions.initGeneration,
      (state, { payload: { cancelTokenSource } }) => {
        state.generating = true
        state.error = null
        state.cancelTokenSource = cancelTokenSource
      }
    )
    .addCase(AIInternalActions.resetGeneration, (state) => {
      state.generating = false
      state.cancelTokenSource = null
    })
    .addCase(AIInternalActions.setGenerating, (state, { payload }) => {
      state.generating = payload
    })
    .addCase(AIInternalActions.setHistoryLoading, (state, { payload }) => {
      state.historyLoading = payload
    })
    .addCase(AIInternalActions.setError, (state, { payload }) => {
      state.error = payload
    })
    .addCase(AIInternalActions.setMessages, (state, { payload }) => {
      state.messages = payload
    })
    .addCase(AIExternalActions.addMessage, (state, { payload }) => {
      state.messages.push(payload.message)
    })
    .addCase(
      AIInternalActions.updateRemainingRequests,
      (state, { payload }) => {
        state.remainingRequests = payload
      }
    )
    .addCase(AIInternalActions.removeLastMessage, (state) => {
      state.messages.pop()
    })
    // v2 (chat-agent) streaming cases.
    .addCase(AIInternalActions.startStream, (state) => {
      state.generating = true
      state.error = null
      state.streamingText = ''
      state.agentStep = null
      state.agentStatus = null
    })
    .addCase(AIInternalActions.setSessionId, (state, { payload }) => {
      state.sessionId = payload
    })
    .addCase(AIInternalActions.appendStreamText, (state, { payload }) => {
      state.streamingText = (state.streamingText ?? '') + payload
    })
    .addCase(AIInternalActions.setAgentStep, (state, { payload }) => {
      state.agentStep = payload
    })
    .addCase(AIInternalActions.setAgentStatus, (state, { payload }) => {
      state.agentStatus = payload
    })
    .addCase(AIInternalActions.commitStreamedMessage, (state) => {
      if (state.streamingText && state.streamingText.trim().length > 0) {
        state.messages.push({
          type: 'assistant',
          text: state.streamingText,
        })
      }

      state.streamingText = null
      state.agentStep = null
      state.agentStatus = null
    })
    .addCase(AIInternalActions.resetStream, (state) => {
      state.streamingText = null
      state.agentStep = null
      state.agentStatus = null
    })
    .addCase(AIInternalActions.setLastSentMessage, (state, { payload }) => {
      state.lastSentMessage = payload
    })
})
